<script setup lang="ts">
interface Props {
  link?: {
    isPrimary?: boolean
    icon?: ReturnType<typeof resolveComponent>
    label?: string | null
    action: () => void
  }
}

const props = withDefaults(defineProps<Props>(), {
  link: () => ({
    isPrimary: false,
    icon: undefined,
    label: undefined,
    action: () => {},
  }),
})

function handleClick() {
  if (props.link && props.link.action) {
    props.link.action()
  }
}
</script>

<template>
  <a
    href="#"
    class="flex cursor-pointer items-center whitespace-nowrap rounded p-2 font-light hover:bg-gray-50"
    :class="{ 'link-primary': link.isPrimary }"
    @click.prevent.stop="handleClick"
  >
    <span class="mr-4 rounded bg-gray-50 p-2">
      <component
        :is="link.icon"
        class="h-5 w-5 text-pink-500"
      />
    </span>
    {{ link.label }}
  </a>
</template>
